import type { AdImageText } from "~/lib/server-functions/get-ads";
import { Button } from "../ui/button";
import { Link } from "@tanstack/react-router";
import { IMAGE_SIZES, buildImageUrl } from "~/lib/utils";

export function ImageWithTextAd({ ad }: { ad: AdImageText }) {
  const imageUrl = ad.imageIdentifier
    ? buildImageUrl(ad.imageIdentifier, { size: IMAGE_SIZES.cardThumb })
    : null;

  return (
    <div className="p-2 bg-white rounded-md shadow grid grid-cols-2 gap-4">
      {imageUrl && (
        <img
          src={imageUrl}
          alt={ad.header || "Ad image"}
          className="w-full h-auto rounded-md"
        />
      )}
      <div className="text-center flex flex-col justify-center items-center gap-5">
        {ad.header && <h2 className="text-2xl font-semibold">{ad.header}</h2>}
        {ad.subheader && <p className="text-neutral-darker">{ad.subheader}</p>}
        {ad.resolvedLink && (
          <Button asChild variant={"outline"} size={"lg"}>
            <Link to={ad.resolvedLink} rel="noopener noreferrer">
              {ad.label}
            </Link>
          </Button>
        )}
      </div>
    </div>
  );
}
